import { render, staticRenderFns } from "./AuthorAvatar.vue?vue&type=template&id=4c839b9a&scoped=true&"
import script from "./AuthorAvatar.vue?vue&type=script&lang=js&"
export * from "./AuthorAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c839b9a",
  null
  
)

export default component.exports